import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** CLOUDWEB-17703 Сверстать страницу Доступные мне в документах */
export const showAllDocumentsIncomingPublic = isFeature('alldocuments-incoming-public');

/** B2BCLOUD-5593 Добавить раздел "Доступные по ссылке" */
export const showAllIncomingPublic = isFeature('all-incoming-public');
